import {
  APPROVAL_STATUS_LABELS,
  type ApprovalStatus,
} from '@/utils/catalog/approvalStatus'

import cn from '../CatalogApproval.module.scss'

const STATUS_CHIP_CLASS: Record<ApprovalStatus, string> = {
  DRAFT: cn.statusChipDraft,
  APPROVED: cn.statusChipApproved,
  REJECTED: cn.statusChipRejected,
}

function StatusChip({ status }: { status?: ApprovalStatus }) {
  const normalizedStatus = status ?? 'APPROVED'

  return (
    <span
      className={[cn.statusChip, STATUS_CHIP_CLASS[normalizedStatus]].join(' ')}
    >
      {APPROVAL_STATUS_LABELS[normalizedStatus]}
    </span>
  )
}

export default StatusChip
